<autocomplete-list-item (clicked)="triggerEvent()">
  <div class="header">{{ item.name }}</div>
  <div>{{ item.description }}</div>
</autocomplete-list-item>
